import React from 'react';
import { CALENDAR_LINK } from '../../../constants/common';

const Contact = () => {
  return (
    <div className="bg-black p-4 md:p-[50px] md:py-[80px]  max-w-2xl md:max-w-7xl m-auto rounded-[36px] ">
      <div className=" mx-auto flex flex-col lg:flex-row items-center justify-between px-2 md:px-6">
        
        <div className=" text-white flex flex-col gap-6 rounded-lg justify-start items-start text-left  md:w-3/4">
          <div className="text-2xl md:text-5xl font-bold mb-4">
            Looking to know more? Let’s connect <span role="img" aria-label="peace">✌️</span>
          </div>
          <div className="text-18 w-4/5">
            Schedule a personalized demo to explore our game-changing platform
          </div>
          <button className="bg-white text-black rounded-full px-6 py-3 text-lg font-semibold shadow-lg hover:bg-gray-100 transition mt-2w-fit self-center md:self-start "
            onClick={() => window.open(CALENDAR_LINK, '_blank', 'noopener,noreferrer')}>
            Schedule a call
          </button>
        </div>
    <div> 
        <div className="flex flex-col items-center mt-8 lg:mt-0 bg-white p-5 md:p-10 gap-4 md:gap-10 w-[250px] h-[270px]  md:w-[475px] md:h-[460px] rounded-3xl justify-between">
         <img src='assets/images/favicon.png'
         className='object-cover rounded-2xl w-[120px] h-[120px] md:w-[230px] md:h-[235px]'/>
         <div className=' text-[22px] md:text-[30px] font-semibold  text-center'>We’re the replacement you’ve been searching for!</div>
        </div>

      </div>
      </div>

    </div>
  );
};

export default Contact;
